module.exports = __webpack_public_path__ + "img/integral.d78685bb.jpg";